<script lang="ts">
	//UI
	import Editor from "@tinymce/tinymce-svelte";
	//Utils
	//Types
	//Props
	export let apiKey: string =
		"nqo1wyruv063uttoar1ywjr2hkey7nuca5ho7e4zne55govv";
	export let value = "";
	export let conf: {} = {};
	export let consistentHeight = true;
	//Constants
	//Variables
	//Functions
	//Do
</script>

<div class="editor" class:consistentHeight={consistentHeight}>
	<Editor apiKey={apiKey} conf={conf} bind:value={value} />
</div>

<style lang="scss">
	:global(.tox div[role="menuitemcheckbox"][title="제목"]) {
		height: 42px;
	}
	.editor {
		width: 100%;
		height: 100%;

		:global(.tinymce-wrapper) {
			height: 100%;
			position: relative;
		}
		:global(.tox-edit-area) {
			position: relative;
		}

		:global(.tox-tinymce) {
			border-radius: 5px;
		}
		:global(img.user-import) {
			max-width: 100%;
		}
		&.consistentHeight {
			:global(.tox.tox-tinymce) {
				height: 100% !important;
			}
		}
	}
</style>
